import { adminHttpClient } from '../../../commons/adminHttpClient'
import { NamedItem } from 'domain/common/namedItem'

export interface RenewalClassesDTO {
  id: string
  name: string
}

export interface RenewalEmployeeDTO {
  id: string
  classId: string
}

export interface EligibleEmployeeInfoDto {
  EmployeeId: string
  firstName: string
  lastName: string
  workEmail: string
  employmentStatus: string
  employeeClass: string
  renewalClass: NamedItem
  employeeId: string
  ineligible: boolean
}

export const getAllEligibleEmployees = (): Promise<any> => {
  return adminHttpClient.get('/AdminDashboard/Renewal/ConfirmEligibleEmployeeClasses/AllEligibleEmployees')
}

export const getQsehraAllEligibleEmployeesForRenewal = (): Promise<EligibleEmployeeInfoDto> => {
  return adminHttpClient.get('/AdminDashboard/Renewal/GetQsehraAllEligibleCompanyUsersForRenewal')
}

export const getRenewalClasses = (): Promise<RenewalClassesDTO[]> => {
  return adminHttpClient.get('/AdminDashboard/Renewal/ConfirmEligibleEmployeeClasses')
}

export const submitEmployeeWithRenewalClasses = (payload: RenewalEmployeeDTO[]): Promise<any> => {
  return adminHttpClient.post('/AdminDashboard/Renewal/ConfirmEligibleEmployeeClasses', payload)
}
